module.exports = [
	{
		"id": "walnut",
		"name": "胡桃木",
		"type": "shader",
		"shader_id": "wood",
		"uniforms": {
			"inheritFrom": "phong",
			"scale": {
				"type": "f",
				"value": 0.017
			},
			"radiusScale": {
				"type": "f",
				"value": 0.36
			},
			"verticalScale": {
				"type": "f",
				"value": 0.2
			},
			"tilt": {
				"type": "f",
				"value": 0
			},
			"tiltAxis": {
				"type": "v3",
				"value": {
					"x": 1,
					"y": 0,
					"z": 0
				}
			},
			"woodOffsetX": {
				"type": "f",
				"value": -757
			},
			"woodOffsetZ": {
				"type": "f",
				"value": 0
			},
			"woodGapFactor": {
				"type": "f",
				"value": 0.42
			},
			"woodRingDistoration": {
				"type": "f",
				"value": 1.3
			},
			"woodGrowthVariation": {
				"type": "f",
				"value": 3
			},
			"color1": {
				"type": "c",
				"value": "0x8F634E"
			},
			"color2": {
				"type": "c",
				"value": "0x845541"
			}
		}
	},
	{
		"id": "walnut_horizontal",
		"inheritFrom": "walnut",
		"uniforms": {
			"scale": {
				"type": "f",
				"value": 0.008
			},
			"tilt": {
				"type": "f",
				"value": 90
			},
			"tiltAxis": {
				"type": "v3",
				"value": {
					"x": 0,
					"y": 1,
					"z": 0
				}
			},
			"woodOffsetX": {
				"type": "f",
				"value": -810
			}
		}
	},
	{
		"id": "walnut_leg",
		"inheritFrom": "walnut",
		"uniforms": {
			"tilt": {
				"type": "f",
				"value": 15
			},
			"tiltAxis": {
				"type": "v3",
				"value": {
					"x": -1,
					"y": 0,
					"z": 1
				}
			}
		}
	},
	{
		"id": "white_oak",
		"name": "白橡木",
		"type": "shader",
		"shader_id": "wood",
		"uniforms": {
			"inheritFrom": "phong",
			"scale": {
				"type": "f",
				"value": 0.017
			},
			"radiusScale": {
				"type": "f",
				"value": 0.36
			},
			"verticalScale": {
				"type": "f",
				"value": 0.2
			},
			"tilt": {
				"type": "f",
				"value": 32
			},
			"tiltAxis": {
				"type": "v3",
				"value": {
					"x": 1,
					"y": 0,
					"z": 0
				}
			},
			"woodOffsetX": {
				"type": "f",
				"value": -1000
			},
			"woodOffsetZ": {
				"type": "f",
				"value": -206
			},
			"woodGapFactor": {
				"type": "f",
				"value": 0.562
			},
			"woodRingDistoration": {
				"type": "f",
				"value": 0.4
			},
			"woodGrowthVariation": {
				"type": "f",
				"value": 1
			},
			"color1": {
				"type": "c",
				"value": "0xDEBC91"
			},
			"color2": {
				"type": "c",
				"value": "0xE6C6A0"
			}
		}
	},
	{
		"id": "white_oak_horizontal",
		"inheritFrom": "white_oak",
		"uniforms": {
			"tilt": {
				"type": "f",
				"value": 80
			},
			"tiltAxis": {
				"type": "v3",
				"value": {
					"x": 0,
					"y": 1,
					"z": 0
				}
			}
		}
	},
	{
		"id": "white_oak_leg",
		"inheritFrom": "white_oak",
		"uniforms": {
			"tilt": {
				"type": "f",
				"value": 15
			},
			"tiltAxis": {
				"type": "v3",
				"value": {
					"x": -1,
					"y": 0,
					"z": 1
				}
			}
		}
	},
	{
		"id": "black_wood",
		"name": "黑",
		"color": "0x3C3A3C",
		"type": "lambert"
	},
	{
		"id": "grey_wood",
		"name": "灰",
		"color": "0xC1C3C9",
		"type": "lambert"
	},
	{
		"id": "white_wood",
		"name": "白",
		"color": "0xFFFFFF",
		"type": "lambert"
	},
	{
		"id": "black_paint",
		"name": "黑",
		"color": "0x3F3D3F"
	},
	{
		"id": "grey_paint",
		"name": "灰",
		"color": "0xD5D7DB"
	},
	{
		"id": "white_paint",
		"name": "白",
		"color": "0xEDECE9"
	},
	{
		"id": "dark_grey_paint",
		"name": "鐵灰",
		"color": "0x676360"
	},
	{
		"id": "copper",
		"name": "紅銅",
		"type": "phong",
		"color": "0x9B5035",
		"emissive": "0x666666",
		"specular": "0xFFFFFF",
		"shininess": 100,
		"reflective": true
	},
	{
		"id": "brass",
		"name": "黃銅",
		"type": "phong",
		"color": "0xC3A067",
		"emissive": "0x666666",
		"specular": "0xFFFFFF",
		"shininess": 100,
		"reflective": true
	},
	{
		"id": "brushed_metal",
		"name": "亂紋磨面",
		"type": "shader",
		"shader_id": "brushed_metal",
		"uniforms": {
			"inheritFrom": "standard",
			"roughnessMap": {
				"type": "t",
				"value": "static/images/texture/brushed_metal.jpg"
			},
			"diffuse": {
				"type": "c",
				"value": "0xFFFFFF"
			},
			"metalness": {
				"type": "f",
				"value": 0.5
			},
			"roughness": {
				"type": "f",
				"value": 0.8
			},
			"envMapIntensity": {
				"type": "f",
				"value": 0.7
			}
		}
	},
	{
		"id": "polishing",
		"name": "拋光亮面",
		"type": "phong",
		"color": "0xaaaaaa",
		"emissive": "0x666666",
		"specular": "0xFFFFFF",
		"shininess": 100,
		"reflective": true
	},
	{
		"id": "rattan_round",
		"name": "藤",
		"type": "shader",
		"shader_id": "simple_texture",
		"uniforms": {
			"texture": {
				"type": "t",
				"value": "static/images/texture/rattan_round.png"
			},
			"textureScale": {
				"type": "f",
				"value": 50
			}
		}
	},
	{
		"id": "rattan_round_white",
		"name": "白藤",
		"type": "shader",
		"shader_id": "simple_texture",
		"uniforms": {
			"texture": {
				"type": "t",
				"value": "static/images/texture/rattan_round_white.png"
			},
			"textureScale": {
				"type": "f",
				"value": 50
			}
		}
	},
	{
		"id": "rattan_round_black",
		"name": "黑藤",
		"type": "shader",
		"shader_id": "simple_texture",
		"uniforms": {
			"texture": {
				"type": "t",
				"value": "static/images/texture/rattan_round_black.png"
			},
			"textureScale": {
				"type": "f",
				"value": 50
			}
		}
	},
	{
		"id": "rattan_round_grey",
		"name": "灰藤",
		"type": "shader",
		"shader_id": "simple_texture",
		"uniforms": {
			"texture": {
				"type": "t",
				"value": "static/images/texture/rattan_round_grey.png"
			},
			"textureScale": {
				"type": "f",
				"value": 50
			}
		}
	},
	{
		"id": "rattan_square",
		"name": "藤",
		"type": "shader",
		"shader_id": "simple_texture",
		"uniforms": {
			"texture": {
				"type": "t",
				"value": "static/images/texture/rattan_square.png"
			},
			"textureScale": {
				"type": "f",
				"value": 72
			}
		}
	},
	{
		"id": "rattan_square_white",
		"name": "白藤",
		"type": "shader",
		"shader_id": "simple_texture",
		"uniforms": {
			"texture": {
				"type": "t",
				"value": "static/images/texture/rattan_square_white.png"
			},
			"textureScale": {
				"type": "f",
				"value": 72
			}
		}
	},
	{
		"id": "rattan_square_black",
		"name": "黑藤",
		"type": "shader",
		"shader_id": "simple_texture",
		"uniforms": {
			"texture": {
				"type": "t",
				"value": "static/images/texture/rattan_square_black.png"
			},
			"textureScale": {
				"type": "f",
				"value": 72
			}
		}
	},
	{
		"id": "rattan_square_grey",
		"name": "灰藤",
		"type": "shader",
		"shader_id": "simple_texture",
		"uniforms": {
			"texture": {
				"type": "t",
				"value": "static/images/texture/rattan_square_grey.png"
			},
			"textureScale": {
				"type": "f",
				"value": 72
			}
		}
	},
	{
		"id": "from_taiwan",
		"type": "shader",
		"shader_id": "from_taiwan",
		"uniforms": {
			"inheritFrom": "phong",
			"wordMask": {
				"type": "t",
				"value": "static/images/texture/from_taiwan.png"
			},
			"wordColor": {
				"type": "c",
				"value": "0xFFFFFF"
			},
			"baseColor": {
				"type": "c",
				"value": "0x3F3D3F"
			},
			"wordOffset": {
				"type": "v3",
				"value": {
					"x": 275,
					"y": 0,
					"z": 275
				}
			},
			"wordScale": {
				"type": "f",
				"value": 550
			},
			"wordRotation": {
				"type": "f",
				"value": -100
			}
		}
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/materials.json
// module id = 169
// module chunks = 5